export const trackingEvents = {
  DOWNLOAD_CSV_BUTTON: {
    CLICKED: 'employer_venue_list.download_csv_button.clicked',
  },
}
